export default __webpack_public_path__ + "static/media/student_history.d313e9c0.png";